import { Breadcrumb } from '@chakra-ui/react'
import { ChevronLeftIcon, Flex, Panel, Text } from 'components'
import { Link } from 'react-router'
import { useBreakpoint } from 'utils'
import { useCurrentPage, usePageInfo } from '../utils/pageUtils'

export default function BreadCrumb() {
  const page = useCurrentPage()
  const breakpoint = useBreakpoint()

  const parentPageInfo = usePageInfo(page?.parentPath)
  const pageInfo = usePageInfo(page?.path)

  if (!parentPageInfo) return null

  return (
    <Panel px={3} textStyle="bodySmall" height="40px" gap={1} direction="row" alignItems="center">
      {breakpoint > 2 ? (
        <>
          <ChevronLeftIcon size="sm" />

          <Breadcrumb.Root>
            <Breadcrumb.List>
              <Breadcrumb.Item>
                <Breadcrumb.Link asChild>
                  <Link to={{ pathname: parentPageInfo.path }}>
                    <Text lineClamp={1}>{parentPageInfo?.title}</Text>
                  </Link>
                </Breadcrumb.Link>
              </Breadcrumb.Item>

              <Breadcrumb.Separator>/</Breadcrumb.Separator>

              <Breadcrumb.Item>
                <Breadcrumb.CurrentLink>
                  <Text lineClamp={1}>{pageInfo?.identifier || '--'}</Text>
                </Breadcrumb.CurrentLink>
              </Breadcrumb.Item>
            </Breadcrumb.List>
          </Breadcrumb.Root>
        </>
      ) : (
        parentPageInfo?.path && (
          <Link to={parentPageInfo?.path}>
            <Flex _hover={{ textDecoration: 'underline' }} gap={1} align="center">
              <ChevronLeftIcon fontSize="sm" mx={1} />
              <Text textStyle="bodySmall">Back</Text>
            </Flex>
          </Link>
        )
      )}
    </Panel>
  )
}
